import { render } from "./WorkComp.vue?vue&type=template&id=a28e7328"
import script from "./WorkComp.vue?vue&type=script&lang=js"
export * from "./WorkComp.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/new-portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__